import { GearIcon, GridIcon, PersonIcon, ReaderIcon } from '@radix-ui/react-icons';
import { TeacherHomeNavigation } from './TeacherHomeNavigation';
import './teacher-home.css';
import './teacher-textbook-shell.css';

export interface TeacherTextbookNavigationProps {
  readonly displayName: string;
  readonly onHome: () => void;
  readonly onQuestionBank: () => void;
  readonly onStudents: () => void;
  readonly onAiManagement: () => void;
  readonly onLogout: () => void;
}

export function TeacherTextbookNavigation({
  displayName,
  onHome,
  onQuestionBank,
  onStudents,
  onAiManagement,
  onLogout,
}: TeacherTextbookNavigationProps) {
  return (
    <TeacherHomeNavigation
      currentPage="textbooks"
      displayName={displayName}
      onHome={onHome}
      onLogout={onLogout}
    >
      {(closeNavigation) => (
        <>
          <a
            className="teacher-home__action teacher-home__action--resource teacher-textbook-navigation__current"
            href="#teacher-textbook-heading"
            aria-current="page"
            onClick={(event) => {
              event.preventDefault();
              closeNavigation();
              document.getElementById('teacher-textbook-heading')?.focus();
            }}
          >
            <span className="teacher-home__icon">
              <ReaderIcon aria-hidden="true" />
            </span>
            <span className="teacher-home__copy">
              <strong>我的教材</strong>
            </span>
          </a>
          <button
            className="teacher-home__action teacher-home__action--resource"
            type="button"
            onClick={onQuestionBank}
          >
            <span className="teacher-home__icon">
              <GridIcon aria-hidden="true" />
            </span>
            <span className="teacher-home__copy">
              <strong>题库管理</strong>
            </span>
          </button>
          <button
            className="teacher-home__action teacher-home__action--resource"
            type="button"
            onClick={onStudents}
          >
            <span className="teacher-home__icon">
              <PersonIcon aria-hidden="true" />
            </span>
            <span className="teacher-home__copy">
              <strong>学生信息</strong>
            </span>
          </button>
          <button
            className="teacher-home__action teacher-home__action--resource"
            type="button"
            onClick={onAiManagement}
          >
            <span className="teacher-home__icon">
              <GearIcon aria-hidden="true" />
            </span>
            <span className="teacher-home__copy">
              <strong>AI管理</strong>
            </span>
          </button>
        </>
      )}
    </TeacherHomeNavigation>
  );
}
